export enum ErrorType {
  PAGE_NOT_FOUND = 'pageNotFound',
  SERVER_ERROR = 'somethingWentWrong',
  UNAUTHORIZED = 'accessDenied',
}
